import React from "react";
import Slider from "react-slick";
import { useTranslation, Trans } from "react-i18next";

const TestimonialsSection: React.FC = () => {
  const { t } = useTranslation();

  const partnerLogos = [
    "/images/brand-logo/logo1.webp",
    "/images/brand-logo/logo2.webp",
    "/images/brand-logo/logo3.webp",
    "/images/brand-logo/logo4.webp",
    "/images/brand-logo/logo5.webp",
    "/images/brand-logo/logo6.webp",
  ];

  const sliderSettings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    infinite: true,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 2 } },
    ],
  };

  const feedbacks = t('testimonials.feedbacks', { returnObjects: true }) as Array<{ name: string; city: string; text: string; }>;

  return (
    <div className="w-full bg-gray-100 px-6 py-16 flex flex-col items-center space-y-16">
      <h2 className="pt-10 text-2xl md:text-4xl font-light text-center">
        <Trans i18nKey="testimonials.main_title">
          Khách hàng <span className="text-green-700 font-bold">nói gì về</span> chúng tôi?
        </Trans>
      </h2>

      <div className="w-full max-w-6xl smooth-marquee-container">
        <div className="smooth-marquee-track">
          {Array.from({ length: 2 }).flatMap((_, loopIdx) =>
            feedbacks.map((item, idx) => (
              <div
                key={`${loopIdx}-${idx}`}
                className="min-w-[300px] max-w-sm flex-shrink-0 border p-6 shadow-sm bg-gray-50"
              >
                <p className="text-5xl text-black leading-none mb-1">“</p>
                <p className="text-xl font-semibold text-black mb-1">
                  {item.name} - <span className="text-green-700">{item.city}</span>
                </p>
                <p className="text-sm text-gray-600">“{item.text}”</p>
              </div>
            ))
          )}
        </div>
      </div>

      <div className="text-center w-full pt-20 pb-20">
        <h2 className="text-2xl md:text-4xl font-semibold text-green-700 mb-6">
          <Trans i18nKey="testimonials.partners_title">
            Đối tác <span className="text-black font-light">khách hàng</span>
          </Trans>
        </h2>

        <Slider {...sliderSettings} className="w-full max-w-6xl mx-auto">
          {partnerLogos.map((logo, index) => (
            <div key={index} className="px-4 flex justify-center">
              <img
                src={logo}
                alt={`Partner Logo ${index + 1}`}
                className="max-h-28 md:max-h-32 object-contain transition-transform duration-300 hover:scale-105"
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default TestimonialsSection;